export default "__VITE_ASSET__BPqLbFCs__"